<template>
    <div class="foot-body">
        <div class="footer-title"><span>布瑞琳</span> BRANEW</div>
        <div class="footer-introduction">您的衣物洗护专家</div>
        <div class="foot-consumption">
            <div class="foot-link">
                <img src="../assets/foot-wx.png" alt="">
                <div class="foot-title">公众号</div>
            </div>
            <div class="foot-link">
                <img src="../assets/foot-xcx.png" alt="">
                <div class="fott-title">小程序</div>
            </div>
            <div class="foot-link">
                <img src="../assets/foot-tm.png" alt="">
                <div class="foot-title">旗舰店</div>
            </div>
        </div>
        <div class="footer-contact" @click="$router.push('/contactUs')"><span>联系我们</span> | 人才招聘</div>
        <div class="footer-copyright">版权所有：北京布瑞琳洗染服务有限公司 CopyRight 2013-2030 www.branew.com.cn All Rights Reserved   <span style="margin-left:2rem;">ICP备案证： 京ICP备09006155号</span></div>
    </div>
</template>

<script>
export default {
  name: 'FootNav',

    data() {
      return {
        activeIndex: '/',
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  
}
</script>

<style scoped lang="scss">
.foot-body{
    background: #00146E;
    color: #fff;

    .footer-title{
        font-size: 1.8rem;
        padding-top: 5rem;

        span{
            font-weight: bolder;
        }
    }

    .footer-introduction{
        font-size: 1.2rem;
        margin: 0.5rem 0 2rem;
    }
    
    .foot-consumption{
        margin: 3rem 0;

        .foot-link{
            display: inline-block;
            margin: 0 3rem;

            img{
                width: 2rem;
            }

            .foot-title{
                font-size: 14px;
            }
        }
    }

    .footer-copyright{
        border-top: 1px solid #fff;
        margin-top: 2rem;
        padding: 1rem 0;
        font-size: 1rem;
    }
}

.footer-contact{
    cursor: pointer;
}
</style>
